import { NotificationItem } from '../types';

export const normalizeNotificationType = (type: string): string => {
  const normalizedType = (type || '').trim().toLowerCase();

  if (normalizedType === 'leave' || normalizedType === 'leaveapproval' || normalizedType === 'leave_applied' || normalizedType === 'leave_approval') {
    return 'leave';
  }

  if (
    normalizedType === 'regularization' ||
    normalizedType === 'regularizationapproval' ||
    normalizedType === 'regularization_submitted' ||
    normalizedType === 'regularization_approval'
  ) {
    return 'regularization';
  }

  return normalizedType;
};

export const getNotificationDisplayType = (type: string): string => {
  const normalizedType = (type || '').trim().toLowerCase();

  switch (normalizedType) {
    case 'leave_applied':
      return 'Leave Applied';
    case 'leave_approval':
    case 'leaveapproval':
      return 'Leave Approval';
    case 'leave':
      return 'Leave';
    case 'regularization_submitted':
      return 'Regularization Submitted';
    case 'regularization_approval':
    case 'regularizationapproval':
      return 'Regularization Approval';
    case 'regularization':
      return 'Regularization';
    case 'announcement':
      return 'Announcement';
    case 'attendance':
      return 'Attendance';
    case 'payroll':
      return 'Payroll';
    case 'bgv':
      return 'BGV';
    case 'system':
      return 'System';
    default:
      return type
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (character) => character.toUpperCase());
  }
};

export const getNotificationRoute = (item: NotificationItem): string => {
  const normalizedType = normalizeNotificationType(item.type);

  if (normalizedType === 'leave') {
    return '/leave/requests';
  }

  if (normalizedType === 'regularization') {
    return '/attendance/regularization';
  }

  if (normalizedType === 'attendance') {
    return '/attendance/records';
  }

  return '/notifications';
};